module.exports = __webpack_public_path__ + "static/media/tech-dani.52b9bed5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tech-dani.jpg
// module id = 130
// module chunks = 0